import { splitAdults, type GuestPartyMemberInput } from '@peles/shared';

/**
 * A named person marked coming or not coming moves the party's head count by
 * one of their kind — an unanswered name already counts as coming. An adult
 * leaving comes off the men first, as `splitAdults` takes adults. A party that
 * said no has no head count to move.
 */
export function withMemberAttending<
  F extends { maleCount: number; femaleCount: number; kidCount: number; response: string },
>(form: F, member: GuestPartyMemberInput, attending: boolean): F {
  const wasComing = member.attending !== false;
  if (form.response === 'NO' || wasComing === attending) return form;
  const step = attending ? 1 : -1;
  if (member.memberType === 'CHILD') {
    return { ...form, kidCount: Math.max(0, form.kidCount + step) };
  }
  return {
    ...form,
    ...splitAdults(
      { maleCount: form.maleCount, femaleCount: form.femaleCount },
      form.maleCount + form.femaleCount + step,
    ),
  };
}
